import React from 'react';
import '../styles/HowItWorks.css';

interface Step {
  number: number;
  title: string;
  description: string;
}

const steps: Step[] = [
  {
    number: 1,
    title: 'Choose Service',
    description: 'Select the legal service you need from our comprehensive categories'
  },
  {
    number: 2,
    title: 'Select Location',
    description: 'Choose your city and preferred consultation mode'
  },
  {
    number: 3,
    title: 'Book & Pay',
    description: 'Schedule your appointment and make secure payment'
  },
  {
    number: 4,
    title: 'Get Expert Advice',
    description: 'Receive professional legal consultation at your convenience'
  }
];

const HowItWorks: React.FC = () => {
  return (
    <section className="how-it-works">
      <div className="container">
        <h2 className="section-title animate-fadeInUp">How It Works</h2>
        <div className="steps-container">
          {steps.map((step) => (
            <div 
              key={step.number} 
              className="step animate-fadeInUp"
              style={{ animationDelay: `${step.number * 0.2}s` }}
            >
              <div className="step-number">{step.number}</div>
              <div className="step-content">
                <h3>{step.title}</h3>
                <p>{step.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;